// extracted by mini-css-extract-plugin
export default {"base":"DialogIEAlert_base__afEq8","content":"DialogIEAlert_content__NIl5b","button":"DialogIEAlert_button__LhOXm"};